import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { passwordUpdatedPopupTrns } from "./trns";
import { ModalState } from "src/hooks/useModal";
import { ModalWindowV2 } from "src/components/ModalWindowV2";

interface Props extends ModalState {}

export const PasswordUpdatedPopup: FC<Props> = ({ ...modalProps }) => {
  const { t } = useTranslation();

  return (
    <ModalWindowV2
      {...modalProps}
      className="max-w-111.5 w-full"
      isActiveCloseClickOutside={false}
      isShownCloseButton
      isActivePortal
    >
      <div className="flex flex-col gap-5 p-5 bg-white-base border border-gray-base/20 rounded-20">
        <h3 className="font-semibold text-center">
          {t(passwordUpdatedPopupTrns.title)}
        </h3>

        <p className="text-justify">{t(passwordUpdatedPopupTrns.description)}</p>

        <Button
          variant={ButtonVariants.PRIMARY}
          onClick={modalProps.closeModal}
        >
          {t(passwordUpdatedPopupTrns.gotItButton)}
        </Button>
      </div>
    </ModalWindowV2>
  );
};
